// extracted by mini-css-extract-plugin
export default {"Logo":"StandardRouting_Logo__cuY2M","Navbar":"StandardRouting_Navbar__Py0s1","NavLink":"StandardRouting_NavLink__11B9i"};